<template>
  <v-footer class="caption" small padless>
    <v-spacer></v-spacer>
    © {{ new Date().getFullYear() }} Manuello Design - Tutti i diritti riservati - P.IVA 02291460042 -
    <a :href="urlPrivacy" target="_blank">Privacy policy</a>
    <v-btn icon class="mx-0" href="https://www.facebook.com/manuellodesign/" target="_blank">
      <v-icon size="20px">fab fa-facebook</v-icon>
    </v-btn>
    <v-btn icon class="mx-0" href="https://www.instagram.com/manuellodesign/" target="_blank">
      <v-icon size="20px">fab fa-instagram</v-icon>
    </v-btn>
  </v-footer>
</template>

<script>
export default {
  props: {
    fixed: { type: Boolean, default: false }
  },
  data: vm => ({
    urlPrivacy: vm.$load.getUrlPrivacy()
  }),

  methods: {}
};
</script>
